import {
  allowedFunctionalCookiesForPanel,
  allAllowedCookiesForPanel,
  allAllowedCookies,
  allowedFunctionalCookies,
} from 'config/allowed-cookies'
import { AllAllowedCookies, CookiesArray } from 'models/cookies'
import { getAllowedCookies } from 'services/cookie-service'
import { getLangFromUrl } from 'utils/current-language'
import { isPanelUrl, createUrlWithParams, removeUrlParams, decodeUrlParams, renameQueryParam } from 'utils/urls'

const shouldAddCookiesAsParams = (
  currentHostname: URL,
  targetHostname: URL,
  currentLang: string,
  targetLang: string,
): boolean => {
  return (
    (currentHostname.hostname !== targetHostname.hostname || currentLang !== targetLang) &&
    (currentLang === 'pl' || targetLang === 'pl') &&
    !targetHostname.pathname.includes('wp-content') &&
    !targetHostname.hostname.includes('c1cdn')
  )
}

const handleConditionalRedirects = (): void => {
  const currentUrl = new URL(window.location.href)
  const currentLang = getLangFromUrl()

  renameQueryParam('clickId', 'uap')

  document.addEventListener('click', (event) => {
    let $targetAnchor: HTMLAnchorElement | null = null
    if (event.target instanceof HTMLElement) $targetAnchor = event.target.closest<HTMLAnchorElement>('a')
    if (!$targetAnchor) return

    event.preventDefault() // it's important that this is only after checking if it's a anchor element

    const targetUrl = new URL($targetAnchor.href)
    const targetLang = getLangFromUrl(targetUrl.pathname)
    let cookiesArray: CookiesArray

    if (shouldAddCookiesAsParams(currentUrl, targetUrl, currentLang, targetLang)) {
      let allowedCookies: AllAllowedCookies[]
      if (window.Cookiebot?.consent?.marketing) {
        allowedCookies = isPanelUrl(targetUrl) ? allAllowedCookiesForPanel : allAllowedCookies
      } else {
        allowedCookies = isPanelUrl(targetUrl) ? allowedFunctionalCookiesForPanel : allowedFunctionalCookies
      }
      cookiesArray = getAllowedCookies(allowedCookies)
    }

    const targetParams = decodeUrlParams(targetUrl.href)
    const currentParams = decodeUrlParams(window.location.href)
    const mergedParams = { ...targetParams, ...currentParams, ...cookiesArray }

    // Remove duplicate parameters
    Object.keys(mergedParams).forEach((key) => {
      if (Array.isArray(mergedParams[key])) {
        mergedParams[key] = [...new Set(mergedParams[key])]
      }
    })

    window.location.href = createUrlWithParams(mergedParams, targetUrl)
  })
}

const clearNonMarketingCookiesFromUrl = (): void => {
  const params = getAllowedCookies(allowedFunctionalCookies)
  const url = removeUrlParams(window.location.href, Object.keys(params))
  window.history.replaceState(null, '', url)
}

export const initHandleConditionalRedirects = (): void => {
  clearNonMarketingCookiesFromUrl()
  handleConditionalRedirects()
}
